import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Input, AutoComplete, Button } from 'antd'

const { Option } = AutoComplete

function normaliseSupplierList(list) {
  return Array.isArray(list) ? list.filter(Boolean) : []
}

/**
 * Supplier picker for invoice upload review.
 * Props match ReviewUploadFocusCard: data, onSelect(id, title), custom, placeholder.
 */
function AutoCompleteFilter({
  data,
  initialSuppleirs,
  placeholder = 'Choose your supplier',
  onSelect,
  addCustomSupplier,
  updateFiles,
  index,
  custom = '',
}) {
  // Prefer `data` (current upload UI); fall back to legacy `initialSuppleirs`.
  const supplierOptions = useMemo(() => {
    if (Array.isArray(data)) return data.filter(Boolean)
    return normaliseSupplierList(initialSuppleirs)
  }, [data, initialSuppleirs])

  const [filteredSupplier, setFilteredSupplier] = useState(supplierOptions)
  const [inputValue, setInputValue] = useState('')
  const [otherModal, setOtherModal] = useState(false)
  const [customSupplier, setCustomSupplier] = useState(custom || '')

  useEffect(() => {
    setFilteredSupplier(supplierOptions)
  }, [supplierOptions])

  useEffect(() => {
    setCustomSupplier(custom || '')
  }, [custom])

  const handleSearch = value => {
    const query = String(value || '').toLowerCase()
    if (!query) {
      setFilteredSupplier(supplierOptions)
      return
    }
    setFilteredSupplier(
      supplierOptions.filter(supplier =>
        String(supplier.supplierTitle || '')
          .toLowerCase()
          .includes(query),
      ),
    )
  }

  const emitSelect = (id, title) => {
    if (typeof onSelect === 'function') {
      onSelect(id, title)
      return
    }
    if (typeof updateFiles === 'function') {
      updateFiles(id, title, index)
    }
  }

  const handleSelect = (value, option) => {
    if (value === 'Other') {
      setOtherModal(true)
      return
    }
    setCustomSupplier(value)
    emitSelect(option.key, value)
  }

  const onBtnSave = () => {
    const title = String(inputValue || '').trim()
    if (!title) return

    const newSupplier = {
      _id: title,
      supplier: { _id: title },
      supplierTitle: title,
    }
    emitSelect(null, title)
    if (typeof addCustomSupplier === 'function') {
      addCustomSupplier(newSupplier)
    }
    setFilteredSupplier(prev => [...normaliseSupplierList(prev), newSupplier])
    setCustomSupplier(title)
    setInputValue('')
    setOtherModal(false)
  }

  const options = [
    ...normaliseSupplierList(filteredSupplier),
    { _id: 'other', supplier: { _id: 'other' }, supplierTitle: 'Other' },
  ]

  return (
    <>
      <AutoComplete
        size='large'
        style={{ width: '100%' }}
        onSearch={handleSearch}
        onSelect={handleSelect}
        onChange={value => {
          setCustomSupplier(value)
          handleSearch(value)
        }}
        notFoundContent='Supplier not found'
        placeholder={placeholder}
        value={customSupplier && !otherModal ? customSupplier : undefined}
      >
        {options.map(supplier => (
          <Option key={supplier._id} value={supplier.supplierTitle}>
            {supplier.supplierTitle}
          </Option>
        ))}
      </AutoComplete>
      <Modal
        width='14%'
        title={
          <p style={{ textAlign: 'center', padding: 0, margin: 0 }}>
            Enter your supplier
          </p>
        }
        okText='Save'
        visible={otherModal}
        closeIcon={null}
        centered
        closable={false}
        footer={false}
        onCancel={() => setOtherModal(false)}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Input
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
          />
          <Button
            type='primary'
            style={{ marginTop: '10px' }}
            onClick={onBtnSave}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default AutoCompleteFilter
